// src/features/auth/authAPI.js
import axiosInstance from '../../api/axiosInstance';
import { V1_API_ORIGIN } from '../../config/constants.config';

export const loginAPI = async (credentials) => {
    const response = await axiosInstance.post('/users/login', credentials);
    return response.data;
};

export const otpVerifyService = async (credentials) => {
    const response = await axiosInstance.post('/users/otp-verify', credentials);
    return response.data;
};

export const updateUserDetailService = async (params) => {
  const uid = localStorage.getItem("uid");
  const payload = {...params};
  const response = await axiosInstance.post(`${V1_API_ORIGIN}/users/${uid}`, payload);
  return response.data;
}

export const logoutService = async () => {
    const response = await axiosInstance.get('/users/logout');
    return response.data;
};

export const fetchUserLoginDetailService = () => {
  return axiosInstance.get(`${V1_API_ORIGIN}/users/me`);
}

export const sendVerificationOtpService = async (payload) => {
  const response = await axiosInstance.post(
    `${V1_API_ORIGIN}/users/send-verification-otp`,
    payload,
  );

  if (response.data?.status === false) {
    throw new Error(response.data?.message || "Unable to send verification OTP.");
  }

  return response.data;
};

export const verifyVerificationOtpService = async (payload) => {
  const response = await axiosInstance.post(
    `${V1_API_ORIGIN}/users/verify-verification-otp`,
    payload,
  );

  if (response.data?.status === false) {
    throw new Error(response.data?.message || "Unable to verify OTP.");
  }

  return response.data;
};

